import { Box, Stack, Text } from "@chakra-ui/react";
import WhiteBgInput from "../WhiteBgInput";
import {
  datetimeLocalValueToEventWall,
  eventWallToDatetimeLocalValue,
} from "../utils/guidedScheduleEventWall";
import { GUIDED_EDIT_DEFAULT_TIMEZONE } from "@common/interfaces/adsManagerGuidedEdit";

type GuidedScheduleEditorProps = {
  /** IANA zone for the linked event; wall times below are interpreted here. */
  eventTimezone?: string;
  startAt: string;
  endAt: string;
  onChangeStartAt: (value: string) => void;
  onChangeEndAt: (value: string) => void;
  /** When true, the start datetime control is read-only. */
  isStartAtDisabled?: boolean;
};

export default function GuidedScheduleEditor({
  eventTimezone = GUIDED_EDIT_DEFAULT_TIMEZONE,
  startAt,
  endAt,
  onChangeStartAt,
  onChangeEndAt,
  isStartAtDisabled = false,
}: GuidedScheduleEditorProps) {
  const tz = eventTimezone;
  const startInput = eventWallToDatetimeLocalValue(startAt, tz);
  const endInput = eventWallToDatetimeLocalValue(endAt, tz);

  return (
    <Box
      p={4}
      borderRadius="xl"
      border="1px solid"
      borderColor="gray.200"
      bg="white"
      w="full"
    >
      <Text fontWeight="semibold" color="gray.800" mb={1}>
        Schedule (start to end)
      </Text>
      <Text fontSize="sm" color="gray.600" mb={4}>
        How long this ad should run
      </Text>
      <Stack
        spacing={2}
        align="stretch"
        w="full"
        direction={{ base: "column", "2xl": "row" }}
      >
        <Box flex={1} position="relative">
          <WhiteBgInput
            type="datetime-local"
            value={startInput}
            onChange={(e) =>
              onChangeStartAt(datetimeLocalValueToEventWall(e.target.value, tz))
            }
            py={3}
            w="full"
            fontSize="sm"
            isDisabled={isStartAtDisabled}
            opacity={isStartAtDisabled ? 0.7 : undefined}
            cursor={isStartAtDisabled ? "not-allowed" : undefined}
          />
        </Box>
        <Text
          flexShrink={0}
          color="gray.500"
          fontWeight="medium"
          px={1}
          alignSelf="center"
        >
          →
        </Text>
        <Box flex={1} position="relative">
          <WhiteBgInput
            type="datetime-local"
            value={endInput}
            onChange={(e) =>
              onChangeEndAt(datetimeLocalValueToEventWall(e.target.value, tz))
            }
            py={3}
            w="full"
            fontSize="sm"
          />
        </Box>
      </Stack>
    </Box>
  );
}
